const MottoAlignersRFV = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.9992 19.8539C19.9992 21.0401 19.0714 22 17.9283 22C16.7852 22 15.8584 21.0391 15.8584 19.8539V10.3676C15.8584 7.01857 13.2448 4.30304 10.0166 4.29322H9.96919C6.74754 4.31093 4.14078 7.0236 4.14078 10.3686V19.8539C4.14078 21.0401 3.21301 22 2.07086 22C0.926816 22 0 21.0391 0 19.8539V10.3676C0 4.66008 4.44903 0.0294591 9.94838 0H10.0281C15.5379 0.0157367 20 4.65227 20 10.3676L19.9992 19.8539Z"
			fill="#006262"
		/>
	</svg>
);

export default MottoAlignersRFV;
